import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { ActionTypes, Actions } from '../actions/dco.action';
import { OrderBuilderActions, RESET_BUILDER } from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';

export interface SpecialScenario {
    formId: string;
    values: { [key: string]: boolean };
    valuesAsArray: boolean[];
}

export interface State extends EntityState<SpecialScenario> {
    selectedSpecialScenario: string | undefined;
}

export const adapter: EntityAdapter<SpecialScenario> = createEntityAdapter<SpecialScenario>({
    selectId: (_aux: SpecialScenario) => _aux.formId,
    sortComparer: false,
});

const initialState: State = adapter.getInitialState({
    selectedSpecialScenario: undefined,
});

export function reducer(state = initialState, action: Actions | OrderBuilderActions): State {
    switch (action.type) {
        case ActionTypes.SET_SPECIAL_SCENARIOS: {
            const booleanArray = [];
            if (Object.entries(state.entities).length > 0) {
                let aux: {[key: string]: boolean};
                if (state.entities[action.payload.formId] != undefined) {
                    aux = {
                        ...state.entities[action.payload.formId].values,
                        ...action.payload.scenarios,
                    };
                } else {
                    aux = {
                        ...action.payload.scenarios,
                    };
                }
                for (const key of Object.keys(aux)) {
                    booleanArray.push(aux[key]);
                }
                return adapter.upsertOne(
                    {
                        formId: action.payload.formId,
                        values: aux,
                        valuesAsArray: booleanArray,
                    },
                    state,
                );
            } else {
                for (const key of Object.keys(action.payload.scenarios)) {
                    booleanArray.push(action.payload.scenarios[key]);
                }
                return adapter.upsertOne(
                    {
                        formId: action.payload.formId,
                        values: action.payload.scenarios,
                        valuesAsArray: booleanArray,
                    },
                    state,
                );
            }
        }

        case ActionTypes.REMOVE_SPECIAL_SCENARIO: {
            const booleanArray = [];
            if (Object.entries(state.entities).length > 0) {
                let aux: {[key: string]: boolean};
                if (state.entities[action.payload.formId] != undefined) {
                    state.entities[action.payload.formId].values;
                    aux = {};
                    for ( const clave in  state.entities[action.payload.formId].values) {
                        if (clave !== action.payload.scenario) {
                            aux[clave] = state.entities[action.payload.formId].values[clave];
                        }
                    }
                }
                for (const key of Object.keys(aux)) {
                    booleanArray.push(aux[key]);
                }
                return adapter.upsertOne(
                    {
                        formId: action.payload.formId,
                        values: aux,
                        valuesAsArray: booleanArray,
                    },
                    state,
                );
            } else {
                return state;
            }
        }
        case RESET_BUILDER: {
            return adapter.removeAll(state);
        }
        default: {
            return state;
        }
    }
}

const {
  selectEntities,
} = adapter.getSelectors();

export const selectAllEntities = selectEntities;

